import React from 'react'
import { connect } from 'react-redux'
import * as SLHelper from 'helpers/seaLice'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import SiteFilter from './SiteFilter'
import BarriosFilter from './BarriosFilter'

function OptionFilters(props) {
  const { activeView } = props

  switch (activeView) {
    case SLHelper.LIST_VIEW_MY_SITES:
      return ifWindowWidthLessThan(992) ? null : <SiteFilter />
    case SLHelper.LIST_VIEW_BARRIOS:
      return <BarriosFilter />
    default:
      return null
  }
}

export default connect(state => ({
  activeView: state.getIn(['seaLice', 'activeView']),
  activeMap: state.getIn(['seaLice', 'activeMap']),
}))(OptionFilters)
